import React from "react";

export interface ConditionalController<T> {
    show: (data: T) => void,
    close: () => void,
    render: () => any,
    isShowing: () => boolean,
}

export function useConditional<T>(renderFunction: (data: T) => any): ConditionalController<T> {

    const [showing, setShowing] = React.useState<T>();

    function show(data: T) {
        setShowing(data);
    }

    function close() {
        setShowing(undefined);
    }

    function render() {
        return showing ? renderFunction(showing) : undefined;
    }

    function isShowing() {
        return (showing !== undefined);
    }

    return {
        show,
        close,
        render,
        isShowing,
    };

}